import React from 'react'
import { Grid } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import CardHeader from '@mui/material/CardHeader';
import '../Mapas_Detalhes/Mapas_Detalhes.css';
import { formatarTelefone, formatarCEP } from './../../utils';

function Mapas_Detalhes(props) {
    return (
        <div>
            {
                <div style={{ overflowX: 'auto', overflowY: 'auto' }}>
                    {
                        props?.posicao.map((item, index) => {
                            return (
                                <a href="#" id={"MyLinkFilial_" + item.filial}  onClick={(e) => props.filialClicada(e)}>
                                    <div key={"Filial_" + item.filial} id={"Filial_" + item.filial}>
                                        <Grid container>
                                            <CardHeader
                                                avatar={
                                                    <Avatar
                                                        bgcolor="success.main"
                                                        width='10px'
                                                        height='10px'
                                                        sx={{ bgcolor: "success.main", fontSize: '18px', fontWeight: 'bold' }}
                                                    >{item.filial}</Avatar>
                                                }
                                                titleTypographyProps={{ variant: 'subtitle1' }}
                                                title={"NAFIL AUTO PEÇAS"}
                                            />
                                            <Grid item xs={12} className="spanSmall" style={{ marginTop: '-15px' }}>{item.rua + ", " + item.numero}</Grid>
                                            <Grid item xs={12} className="spanSmall">{item.bairro}</Grid>
                                            <Grid item xs={12} className="spanSmall">{ formatarCEP(item.cep) }</Grid>
                                            <Grid item xs={12} className="spanSmallLightBold">{item.cidade + " - " + item.sigla}</Grid>

                                            <Grid item xs={12} className="spanSmallBold" sx={{ marginTop: '4px' }}>{ formatarTelefone(item.telefone) }</Grid>

                                            {/* <Grid item xs={12} className="spanSmallBold" sx={{ marginTop: '4px' }}>{item.telefone.replace(/\D/g, '').replace(/(\d{2})(\d)/, '($1) $2').replace(/(\d{4})(\d)/, '$1-$2').replace(/(-\d{4})\d+?$/, '$1')}</Grid> */}
                                            <Grid item xs={12} style={{ borderBottom: 'solid #ccc', borderWidth: '1px', marginLeft: '10px', marginRight: '10px' }}>&nbsp;</Grid>
                                        </Grid>
                                    </div>
                                </a>
                            )

                        })
                    }
                </div>
            }
        </div>
    );
}
export default Mapas_Detalhes;

